import React from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
  const isLoggedIn = (sessionStorage.getItem("isLoggedIn") || localStorage.getItem("isLoggedIn")) === "true";
  const isHrmsUser = (sessionStorage.getItem("hrmsUser") || localStorage.getItem("hrmsUser")) === "true";

  if (!token || !isLoggedIn || !isHrmsUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};